{% block swag_cms_extensions_form_editor_settings_field_type_base %}
{% endblock %}
